import { isStringBooleanTrue } from 'src/utils/strings';
import {
  UserSettingMappedValue,
  UserSettingValue,
  UserSettingValueMap,
} from './user-setting-value.types';

export const formatUserSettings = (
  userSettingValues: UserSettingValue[],
): UserSettingValueMap => {
  return new Map(
    userSettingValues.map((userSettingValue) => [
      userSettingValue.userSettingId,
      {
        value: mapUserSettingValueByType(userSettingValue.valueType, userSettingValue.value),
        userSettingValue,
      },
    ]),
  );
};

function mapUserSettingValueByType(type: string, value: string): UserSettingMappedValue {
  switch (type) {
    case 'string':
      return value;
    case 'string[]':
      return value
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    case 'number':
      return Number(value);
    case 'number[]':
      return value
        .split(',')
        .map((item) => Number(item.trim()))
        .filter(Boolean);
    case 'boolean':
      return isStringBooleanTrue(value);
    default:
      console.error(new Error(`Unsupported type: ${type}`));
      return null;
  }
}
